import React, { useState } from 'react';
import { LogOut, ExternalLink, ShieldAlert } from 'lucide-react';
import { useAuth } from '../AuthContext';
import AthleteAuth from './AthleteApp';
import AthleteDashboard from './AthleteDashboard';

const ROLE_LABELS = {
  super_admin: 'Super Admin',
  school_admin: 'School Admin',
  coach: 'Coach',
  demo: 'Demo',
  parent: 'Parent',
};

/**
 * Entry point for /athlete.
 *
 * Guardians get the profile builder. Anyone else -- a coach or an admin whose
 * credentials are perfectly valid -- gets told so plainly. Previously this
 * re-rendered the sign-in form for them, which was indistinguishable from the
 * password being wrong even though the login had actually succeeded.
 */
const AthletePortal = () => {
  const { user, logout } = useAuth();
  const [justAuthed, setJustAuthed] = useState(null);
  const current = user || justAuthed;

  if (!current) {
    return <AthleteAuth onAuthed={(u) => { setJustAuthed(u); window.location.reload(); }} />;
  }

  if (current.role !== 'guardian') {
    return (
      <div className="min-h-screen bg-[#0A0E27] flex items-center justify-center px-4 py-8">
        <div className="max-w-md w-full text-center">
          <div className="w-14 h-14 rounded-full bg-[#FFB300]/12 border border-[#FFB300]/40
                          flex items-center justify-center mx-auto mb-5">
            <ShieldAlert size={24} className="text-[#FFB300]" />
          </div>

          <h1 className="text-white text-xl font-bold mb-2">You&rsquo;re signed in already</h1>
          <p className="text-[#B0BEC5] text-sm leading-relaxed">
            <span className="text-white font-semibold">{current.full_name || current.email}</span> is
            a {ROLE_LABELS[current.role] || current.role} account. This page is the athlete
            portal, where a parent or guardian builds their athlete&rsquo;s recruiting page.
          </p>
          <p className="text-[#B0BEC5] text-sm leading-relaxed mt-3">
            Your account belongs in the main app.
          </p>

          <div className="flex flex-col sm:flex-row gap-2.5 mt-6">
            <a href="/" className="btn-primary flex-1 flex items-center justify-center gap-2">
              <ExternalLink size={15} /> Go to the main app
            </a>
            <button onClick={logout}
              className="btn-secondary flex-1 flex items-center justify-center gap-2">
              <LogOut size={15} /> Sign out
            </button>
          </div>

          <p className="text-[#546E7A] text-xs mt-5">
            Signing out here lets you create or use a guardian account instead.
          </p>
        </div>
      </div>
    );
  }

  return <AthleteDashboard user={current} onLogout={logout} />;
};

export default AthletePortal;
